// extracted by mini-css-extract-plugin
export default {"header":"selections_header__p1JBp","itemsContainer":"selections_itemsContainer__olZsO","rectangle":"selections_rectangle__ncxd9","trashIcon":"selections_trashIcon__u7kMk"};